export default function functionChecker(func) {
  return typeof func === "function";
}
